import { Component, OnInit, HostListener } from '@angular/core';

import * as Services from '@shared/core/services';
import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';
import { tap, take, filter } from 'rxjs/operators';

@Component({
    selector: 'shared-cart',
    templateUrl: './cart.shared.component.html',
    styleUrls: ['./cart.shared.component.scss']
})
export class CartComponent implements OnInit {
    public isLocked: boolean = false;
    public quantity$: Observable<number>;
    public isVisible$: Observable<boolean>;
    public popupAnimation$: Observable<OLO.Animations.IN | OLO.Animations.OUT>;

    @HostListener('click', ['$event']) public tempLock($event: Event): void {
        this.lock();
    }

    @HostListener('window:click', ['$event']) public handleCloseClick($event: Event): void {
        if (this.isLocked) return;

        this.isVisible$.pipe(
            take(1),
            filter(isVisible => !!isVisible),
            tap(() => {
                this.cartService.hidePopup();
            })
        ).subscribe();
    }

    constructor(
        public cartService: Services.CartService,
        public controllers: Controllers,
    ) { }

    ngOnInit(): void {
        this.quantity$ = this.controllers.cart.cartTotalQuantity$();
        this.popupAnimation$ = this.controllers.cart.popupAnimation$();
        this.isVisible$ = this.controllers.cart.isPopupVisible$();
    }

    public lock(): void {
        this.isLocked = true;
        setTimeout(() => {
            this.isLocked = false;
        }, 10);
    }

    public handleCartClick($event: Event): void {
        console.log('CART CLICKED', $event);
    }
}
